/**
 * Created by vlad.p on 8/21/2017.
 */

export class Country {
    public Name: string;
    public Code: string;

    constructor (obj?: Partial<Country>){
        Object.assign(this, obj);
    }
}


// WEBPACK FOOTER //
// ./app/objects/management/locationManagement/Country.ts